import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'billing-paperless-preference',
  templateUrl: './billing-paperless-preference.component.html',
  styleUrls: ['./billing-paperless-preference.component.scss'],
  standalone: false
})
export class BillingPaperlessPreferenceComponent implements OnInit {
  @Input()
  public billAccount: any;

  public options: any[] = [
    {
      value: 'N',
      display: 'No, messaging about "I read T&C" + (add "billing" address below)'
    },
    {
      value: 'Y',
      display: 'Yes, messaging about "I read T&C" + (review "email" addres below)'
    }
  ];

  // -----

  addressForm: UntypedFormGroup;
  emailForm: UntypedFormGroup;
  private billingAddress: AbstractControl;
  private city: AbstractControl;
  state: AbstractControl;
  private zipCode: AbstractControl;
  private emailAddress: AbstractControl;
  paperlessBillingForm: UntypedFormGroup;
  editPaperlessOptions = false;
  private componentData: any;
  states: Array<string> = [];
  private email = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.paperlessBillingForm = this.formBuilder.group({
      paperlessOption: [this.options[1].value]
    });

    this.addressForm = this.formBuilder.group({
      billingAddress: ['', Validators.compose([Validators.required])],
      city: ['', Validators.compose([Validators.required])],
      state: ['', Validators.compose([Validators.required])],
      zipCode: ['', Validators.compose([Validators.required])]
    });

    this.email = 'abc@amfam.com';

    this.emailForm = this.formBuilder.group({
      emailAddress: [{ value: this.email, disabled: true }]
    });

    this.states = this.copyService.get('shared', 'usStates');
  }

  enablePaperBillingOptionForm(value) {
    this.editPaperlessOptions = value === 'N' ? true : false;
  }

  // ToDo: Geo COder Validation
  validateAddress(formData) {}
}
